
import React from 'react'
import { Link } from 'react-admin'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

const CreateNewButton = props => {
    let search
    if (props.createtype === 'contact') {
        if (props.ddorgid) search = `?organization_id=${props.ddorgid}&contactlist_id=${props.record.id}&redirect_origin=${props.redirectorigin}`
        else search = `?contactlist_id=${props.record.id}&redirect_origin=${props.redirectorigin}`
    }
    else {
        search = `?${props.search_id}=${props.orgID}&redirect_origin=${props.redirectorigin}`
    }
    return (
        <Button
            style={{
                fontSize: '10',
                color: "#03a9f4",
                borderRadius: '10px',
                textAlign: 'center',
            }}
            component={Link}
            to={{
                pathname: `/${props.path}/create`,
                search: search,
            }}>
            {props.icon ? props.icon : <div>
                {`Add new ${props.title || props.path}`}</div>}
        </Button>
    );
}

export default CreateNewButton